import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userId = localStorage.getItem('user_id');
    const accessToken = localStorage.getItem('access_token');

    if (userId && accessToken) {
      return true; 
    } else if (userId && !accessToken) {
      // silently token refresh karo
      this.apiService.refreshToken(userId).subscribe((res: any) => {
        if (res.status == 200) {
          localStorage.setItem('access_token', res.access_token);
        }
      });
      return true; 
    } else {
      localStorage.clear();
      this.router.navigate(['/']);
      return false;
    }
  }
}